// Centralised contact + studio details — change in one place
export const PHONE = "+91 80881 63846";
export const PHONE_TEL = "+918088163846";
// WhatsApp — wa.me is the canonical short-link and opens the app on mobile.
export const WHATSAPP = "https://wa.me/918088163846";
export const whatsappWith = (text) =>
  `${WHATSAPP}?text=${encodeURIComponent(text)}`;
// Studio location
export const MAPS_URL = "https://maps.app.goo.gl/2ydDz2agALcWZWsF6";

// Detect if we're inside a (sandboxed) preview iframe. Cross-origin frames
// throw when reading window.top — that's also a positive signal.
const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (err) {
    console.warn("[contact] inIframe check threw (assuming iframe):", err);
    return true;
  }
};

/**
 * External-link click handler.
 *  - In a real browser tab (production): does NOTHING and lets the native
 *    `href + target="_blank"` open a new tab as expected.
 *  - Inside the Emergent preview iframe: pops the link out to a real tab
 *    so it isn't loaded inside the sandbox (Google/WhatsApp block framing).
 */
export const openExternal = (e, url) => {
  if (!inIframe()) return; // let native href handle it
  if (e) e.preventDefault();
  try {
    const w = window.open(url, "_blank", "noopener,noreferrer");
    if (w) return;
  } catch (err) {
    console.warn("[contact] window.open blocked, trying top nav:", err);
  }
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
      return;
    }
  } catch (err) {
    console.warn("[contact] top nav blocked, falling back to same tab:", err);
  }
  window.location.href = url;
};
